<template>
  <div>
    <el-row :gutter="20" v-show="appScope !== 1">
      <el-col :span="8"><div class="head-style">当月活动项目个数：{{ num }}个</div></el-col>
      <el-col :span="8"><div class="head-style">当月活动项目花费金额：{{ amt }}元</div></el-col>
      <el-col :span="8"><div class="head-style">当月活动项目花费翼币：{{ coin }}个</div></el-col>
    </el-row>
    <el-tabs v-model="activeName" v-show="appScope !== 1" type="card" @tab-click="handleClick">
      <el-tab-pane label="进行中的项目" name="1"></el-tab-pane>
      <el-tab-pane label="历史活动" name="2"></el-tab-pane>
    </el-tabs>
    <avue-crud ref="crud" :option="tableOption" :search.sync="search"  :data="tableData" @on-load="getList" :page.sync="page"
               @search-change="searchChange"  v-model="search">
      <template slot="menuLeft" slot-scope="{size}">
        <el-button type="primary" v-if="false" :size="size" @click="btnExport()">导出</el-button>
      </template>
      <template slot="menuRight" slot-scope="{size}">
        <router-link v-show="appScope !== 1" v-if="status!== -1" :to="{path:'/event/detail-add', query: {status: 1}}">
          <el-button type="primary" :size="size">新增活动</el-button>
        </router-link>
      </template>
      <template slot="startTime" slot-scope="scope">
        <span>{{ scope.row.status !==1?(scope.row.startTime?formatDate(scope.row.startTime):'--'):'--' }}</span>
      </template>
      <template slot="cost" slot-scope="scope">
        <span>金额：{{ scope.row.amt>-1?scope.row.amt:'--'}}元</span>
        <br>
        <span>翼币：{{ scope.row.coin>-1?scope.row.coin:'--'}}个</span>
      </template>
      <template slot="amount" slot-scope="scope">
        <span v-show="scope.row.ocRatio>0">运营：{{scope.row.ocRatio}}%</span>
        <br v-show="scope.row.ocRatio>0">
        <span v-show="scope.row.pmRatio>0">PM：{{scope.row.pmRatio}}%</span>
        <br v-show="scope.row.pmRatio>0">
        <span v-show="scope.row.riskRatio>0">风控：{{scope.row.riskRatio}}%</span>
      </template>
      <template slot-scope="{row,index}" slot="menu">
          <el-button type="success" icon="el-icon-document" size="mini" class="m-r-10" @click="toConfig(row)" plain>活动配置</el-button>
      </template>
    </avue-crud>

  </div>
</template>

<script>

import {operationList,operatorTypeEnum,operationTj} from '@/api/events/eventData';
import {statistics} from '@/api/dot/flow'
import {mapGetters, mapState} from "vuex";
import {tableOption} from "@/const/crud/events/eventData";
import {formatDate} from "@/util/date";
import axios from "@/router/axios";

export default {
  props:['appScope','orderId', 'staParams'],
  data() {
    return {
      tempOperatorTypeEnum:[],
      num:0,
      amt:0,
      coin:0,
      activeName: '1',
      dialogVisible:false,
      dialogLimitTime:0,
      dialogWordCount:0,
      dialogFlowId:0,
      page: {
        pageSize: 20,
        pagerCount: 5
      },
      currentRow:{},
      search:{},
      tableData: [],
      tableOption: tableOption,
      status:1,
      staParams: null,
    }
  },
  created() {
    operatorTypeEnum().then(res=>{
      if (this.activeName === '1' && this.appScope !== 1) {
        this.tableOption.column[this.tableOption.column.length - 1].dicData = res.data.data.filter(
          item => item.value < 3);
      } else if (this.activeName === '1' && this.appScope === 1) {
        this.tableOption.column[this.tableOption.column.length - 1].dicData = res.data.data
      } else {
        this.tableOption.column[this.tableOption.column.length - 1].dicData = res.data.data.filter(
          item => item.value > 2);
      }
      this.tempOperatorTypeEnum = res.data.data;
    })
    this.$set(this.tableOption.column[3], 'search', this.appScope !== 1);
  },
  watch:{
    activeName(val, oldVal) {
      if (val === '1') {
        this.tableOption.column[this.tableOption.column.length
        - 1].dicData = this.tempOperatorTypeEnum.filter(item => item.value < 3);
      } else {
        this.tableOption.column[this.tableOption.column.length - 1].dicData = this.tempOperatorTypeEnum.filter(
          it => it.value > 2);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
		next(vm=>{
			vm.curPath = to.path;
			vm.oldPath = from.path;
		})
	},
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  mounted() {
    operationTj().then(res=>{
      let data = res.data.data;
      this.num = data.num;
      this.amt = data.amt;
      this.coin = data.coin;
    })
    this.staParams = {
			u_id: this.userInfo.staffId,
			time: new Date().getTime(),
			browser: navigator.userAgent.toLowerCase(),
			url: document.URL,
			scene_name: '项目活动'
		}
    this.statistics();
  },
  methods: {
    statistics() {
			statistics(Object.assign({
				event_type: 'view',
				ref_url: this.oldPath,
			}, this.staParams))
		},

    toConfig(row) {
      this.$router.push({
        path: '/event/detail-view', 
        query: {status: 2,id:row.id}
      })
      statistics(Object.assign({
        event_name: '活动配置',
        event_type: 'click',
      }, this.staParams))
    },

    btnExport() {
      axios({
        method: 'post',
        url: '/dotadmin/activity/export',
        data: Object.assign(this.search,{tab: this.activeName}),
        responseType: 'blob',   // 重要， 限制返回的数据结构为blob格式，方便前端做转换
      }).then(res => {
        let a = res.headers["content-disposition"]
        let fileName = decodeURIComponent(a.substr(a.indexOf("=")+1))
        const link = document.createElement('a')
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', fileName);
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      });
      statistics(Object.assign({
        event_name: '导出',
        event_type: 'click',
        class_name: 'export',
        class_url: '/dotadmin/activity/export',
        event_params: "Object.assign(this.search,{tab: this.activeName})"
      }, this.staParams))
    },

    init() {
      operationList({
        current: this.page.currentPage,
        size: this.page.pageSize,
        orderId: this.orderId
      }).then(response => {
        this.tableData = response.data.data.records
        this.page.total = response.data.data.total
      })
    },
    searchChange(form, done) {
      this.search = form
      this.page.currentPage = 1
      this.getList(this.page, form)
      done()
    },
    formatDate(time) {
      let date = new Date(parseFloat(time))
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    list (page, params) {
      let target = {
        current: page.currentPage,
        size: page.pageSize,
        tab: this.activeName
      };
      if (this.appScope === 1) {
        target.orderId = this.orderId
        delete target.tab
      }
      delete this.search.tab;
      operationList(Object.assign(target, params, this.search)).then(response => {
        this.tableData = response.data.data.records
        this.page.total = response.data.data.total
      })
    },
    getList(page, params) {
      // if (this.appScope !== 1) {
        this.list(page, params);
      // }
    },
    handleClick(tab, event) {
      // if (tab.name === '1') this.status = 1
      // if (tab.name === '2') this.status = 2
      this.status = parseInt(this.activeName)
      this.getList({
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      }, tab.name === 'five' ? 1 : null);
    },
  },

}
</script>
<style lang="scss" scoped>
.head-style{
  font-size: x-large;
  text-align: center;
}
.avue-view {
  background: #FFFFFF;
  padding: 20px;
}

:deep(.avue-group--card:last-child) {
  margin-bottom: 0px !important;
}

.el-table__body tr.hover-row.current-row > td, .el-table__body tr.hover-row.el-table__row--striped.current-row > td, .el-table__body tr.hover-row.el-table__row--striped > td, .el-table__body tr.hover-row > td {
  background-color: unset;
}

.el-table__expanded-cell[class*=cell] {
  padding: 10px 10px 10px 60px;
}
:deep(.el-table__expanded-cell){
  tr.hover-row{
    background-color: unset !important;
    td{
      background-color: unset !important;
    }
  }
}

:deep(.el-table__expanded-cell[class*=cell]){
  padding: 10px;
}
.dialog-div{
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.slef-footer{
  display: flex;
  justify-content: space-around;
}
</style>

